import { useEffect } from "react";

const usePageTitle = (title?: string) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, []);

  function setTitle(title) {
    document.title = title;
  }
  return setTitle;
};

export default usePageTitle;
